import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import AdditionalDamage from './additional-damage.jsx';

export default class ThisDriversArchivedAdditionalDamages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/additional-damages',
      additionalDamageAccountId: props.additionalDamageAccountId || null,
    };
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/additional-damages/'+
      this.state.additionalDamageAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(additionalDamagesJson) {
      that.setState({
        additionalDamages: additionalDamagesJson,
        isLoading: false
      });
    });
  }

  render() {
    var AdditionalDamagearr = [];

    if (this.state.additionalDamages && this.state.additionalDamages.length > 0) {
      this.state.additionalDamages.forEach(function(i) {
        AdditionalDamagearr.push(<AdditionalDamage key={'additionalDamages-'+i.id} data={i} />);
        });
    }
    return (
        <div>
            <div className="row additionalDamages-table-header">
                <div className="col-md-3">
                    description
                </div>
                <div className="col-md-3">
                    reference
                </div>
                <div className="col-md-2">
                    amounts
                </div>
                <div className="col-md-2">
                    frequency
                </div>
                <div className="col-md-2">
                    details
                </div>
            </div>
            {AdditionalDamagearr}
        </div>
    );
  }
}
